import { inject, Injectable, NgZone, signal } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { SwUpdate, VersionEvent } from "@angular/service-worker";
import { filter, timer } from "rxjs";


@Injectable({ providedIn: 'root' })
export class SoftwareUpdateService {
    // Use { optional: true } to prevent the "No provider" error
    private _swUpdate = inject(SwUpdate, { optional: true });
    private router = inject(Router);
    private zone = inject(NgZone);

    private updateCheckInterval = 30;
    private unsafeRoutes = ['/forms'];
    showSoftwareUpdates = signal(false);
    newVersionAvailable = signal(false);

    constructor() { }

    init() {
        // console.info('SoftwareUpdateService: Initializing!');

        // Check the current route to see if we should interrupt the user with the update.
        // e.g. We should not tell the user to refresh the page while filling out a form.
        //      They would lose their data if they did.
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            const url = event.url.toLowerCase();
            const show = !this.unsafeRoutes.some(route => url.startsWith(route));

            if (this.showSoftwareUpdates() != show) {
                this.showSoftwareUpdates.set(show);
                // console.log('Software Update Notification allowed:', this.showSoftwareUpdates());
            }
        });

        if (!this._swUpdate?.isEnabled) {
            console.warn('SoftwareUpdateService: Updates disabled.');
            return;
        }

        // Watch for service worker version update messages.
        this._swUpdate.versionUpdates
            // .pipe(filter((event): event is VersionReadyEvent => event.type == 'VERSION_READY'))
            .subscribe((versionEvent: VersionEvent) => {
                switch (versionEvent.type) {
                    case 'VERSION_DETECTED':
                        console.info(`New application version found, downloading: ${versionEvent.version.hash}`);
                        break;

                    case 'VERSION_READY':
                        console.info(`New application version ready: ${versionEvent.latestVersion.hash}`);
                        this.newVersionAvailable.set(true);

                        // Immediate activation of the service worker.
                        // We're not doing this as the SW would be newer than the rest of the deployed application.
                        // await this._swUpdate.activateUpdate();
                        break;
                }

                // window.location.reload();
            });

        this.start();
    }

    start() {
        if (!this._swUpdate) return;

        this.zone.runOutsideAngular(() => {
            // interval(this.updateCheckInterval * 1000)
            timer(0, this.updateCheckInterval * 1000)
                .subscribe(() => {
                    // console.debug('Checking for ServiceWorker updates...');
                    this._swUpdate!.checkForUpdate()
                        // .then((updateFound) => {
                        //     console.debug('Version Update Check result:', updateFound);
                        // })
                        .catch((error) => console.error('Check for updates FAILED!', error));
                });
        });
    }

    stop() {
        //
    }
}
